var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown-item",
    {
      staticClass: "cabinet-submenu-item",
      attrs: { to: _vm.to, active: _vm.isActive(_vm.to.name) },
    },
    [
      _vm._t("default"),
      _vm.attention
        ? _c(
            "span",
            {
              staticClass: "cabinet-action-indicator",
              attrs: {
                title: _vm.attentionTitle,
                role: "img",
                "aria-label": "Требуется действие",
              },
            },
            [_vm._v("!")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }